﻿<script>
	import { projectSettings } from "../config";
</script>

<footer>
	<div class="page-footer">
		<img class="logo" src="/img/logo.png" alt="Shine Lawyers" />
		<p class="copyright">&copy; Copyright {new Date().getFullYear()} Shine Lawyers. All Rights Reserved.</p>
	</div>
</footer>

<style>
	footer {
		width: 100%;
		color: #ffffff;
		background-color: #252525;
	}

	footer .logo {
		width: 50%;
	}

	footer .page-footer {
		height: 80px;
		margin: 0 auto;
		display: flex;
		max-width: 80%;
		align-items: center;
		justify-content: space-between;
	}

	footer .copyright {
		margin-top: 16px;
		position: inherit;
		font-size: 13px;
		margin-left: 10%;
		text-align: center;
	}

	@media (min-width: 768px) {
		footer .page-footer {
			height: 155px;
		}

		footer .copyright {
			margin-top: 0;
		}

		footer .logo {
			width: 300px;
		}
	}

	@media (min-width: 992px) {
		footer .copyright {
			font-size: 13px;
			transform: translate(-50%, 0);
			font-family: arial;
			font-weight: 400;
			line-height: 1.5;
		}
	}
</style>
